import { styled, Box, Paper } from '../../../base';

interface IDrawerWrapperProps {
    isOpen: boolean;
}

export const DrawerWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isOpen',
})<IDrawerWrapperProps>(({ theme }) => ({
    position: 'absolute',
    insetInlineStart: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: theme.zIndex.drawer + 1,
}));

export const TabButton = styled(Paper)(({ theme }) => {
    const radius = theme.shape.borderRadius;
    const isRTL = theme.direction === 'rtl';
    return {
        cursor: 'pointer',
        padding: theme.spacing(1.5, 0.5),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.7,
        transition: theme.transitions.create(['opacity', 'transform']),
        writingMode: isRTL ? 'vertical-lr' : 'vertical-rl',
        borderTopRightRadius: isRTL ? 0 : radius,
        borderBottomRightRadius: isRTL ? 0 : radius,
        borderTopLeftRadius: isRTL ? radius : 0,
        borderBottomLeftRadius: isRTL ? radius : 0,
        '&:hover': {
            opacity: 1,
        },
    };
});

interface IDrawerContentProps {
    isOpen: boolean;
}

export const DrawerContent = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'isOpen',
})<IDrawerContentProps>(({ theme, isOpen }) => {
    const isRTL = theme.direction === 'rtl';
    const hiddenTransform = isRTL ? 'translateX(100%)' : 'translateX(-100%)';
    
    return {
        position: 'absolute',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        width: '280px',
        zIndex: theme.zIndex.drawer,
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        transform: isOpen ? 'translateX(0)' : hiddenTransform,
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
    };
});
